const CountryTagDataReference = `
  fragment CountryTagDataReference on CountryTagDataReference {
    countryCode  
    label
    value
  }
`
export default CountryTagDataReference
